import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-external-role-details",
  templateUrl: "./external-role-details.component.html",
  styleUrls: ["./external-role-details.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ExternalRoleDetailsComponent {
  @Input() externalUserId: string = "";
  @Input() externalName: string = "";
  @Input() externalEmail: string = "";
  @Input() externalPhoneNumber: string | null = null;
}
